// extracted by mini-css-extract-plugin
export default {"Box":"issue-type-renderer-module__Box--cz08A","Token":"issue-type-renderer-module__Token--VeuQo"};